import { LoaderCircle } from 'lucide-react'

export const Loading = ({ size = 8 }: { size?: number }) => {
  return (
    <div className="flex items-center justify-center h-full">
      <LoaderCircle
        className={`w-${size} h-${size} animate-spin text-brand_2 dark:text-brand_2/90`}
      />
    </div>
  )
}
